import TrackWrapper from '~/components/common/TrackWrapper';
import formatEvent from '~/utilities/formatEvent';
import VideosCarousel from './VideosCarousel';

export default function Section() {
  return (
    <TrackWrapper
      element="section"
      event={formatEvent('Video Carousel', {
        action: 'viewed'
      })}
      className="flex max-w-full flex-col items-center self-stretch overflow-x-hidden pt-[52px] sm:pt-[40px] md:mx-0 md:px-6xl md:pt-6xl"
    >
      <VideosCarousel />
    </TrackWrapper>
  );
}
